// Lightweight Web Audio "ping" for incoming chat messages (no asset needed).
let audioCtx;

export function playPing() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    audioCtx = audioCtx || new AC();
    if (audioCtx.state === "suspended") audioCtx.resume();
    const now = audioCtx.currentTime;
    const o = audioCtx.createOscillator();
    const g = audioCtx.createGain();
    o.connect(g);
    g.connect(audioCtx.destination);
    o.type = "sine";
    o.frequency.setValueAtTime(740, now);
    o.frequency.exponentialRampToValueAtTime(1180, now + 0.1);
    g.gain.setValueAtTime(0.0001, now);
    g.gain.exponentialRampToValueAtTime(0.16, now + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, now + 0.32);
    o.start(now);
    o.stop(now + 0.34);
  } catch {
    /* audio blocked / unsupported */
  }
}

// Louder, sharper two-tone alert for the mobile in-app new-message banner —
// gain is pushed to the safe maximum (1.0) so it plays as loud as the
// device's current volume setting allows, with a brighter/triangle
// waveform so it reads as more "prominent" / harder to miss than playPing().
export function playLoudChime() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    audioCtx = audioCtx || new AC();
    if (audioCtx.state === "suspended") audioCtx.resume();
    const now = audioCtx.currentTime;
    const notes = [880, 1320];
    notes.forEach((freq, i) => {
      const start = now + i * 0.16;
      const o = audioCtx.createOscillator();
      const g = audioCtx.createGain();
      o.connect(g);
      g.connect(audioCtx.destination);
      o.type = "triangle";
      o.frequency.setValueAtTime(freq, start);
      g.gain.setValueAtTime(0.0001, start);
      g.gain.exponentialRampToValueAtTime(1.0, start + 0.015);
      g.gain.exponentialRampToValueAtTime(0.0001, start + 0.42);
      o.start(start);
      o.stop(start + 0.44);
    });
  } catch {
    /* audio blocked / unsupported */
  }
}
